import { render, staticRenderFns } from "./ModalNotice.vue?vue&type=template&id=63a18991&scoped=true&lang=pug&"
import script from "./ModalNotice.vue?vue&type=script&lang=ts&"
export * from "./ModalNotice.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNotice.vue?vue&type=style&index=0&id=63a18991&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a18991",
  null
  
)

export default component.exports